// Reaproveita 100% a tela de execução de treino do aluno, mas dentro do
// stack do personal — assim o "voltar" leva pra (personal)/my-workout em vez
// de (student)/(tabs).
export { default } from '../../(student)/workout/[planId]';
